exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-entry-flow-modal, .fmcy-entry-flow {\n  background-color: #1c1c1c; }\n\n.fmcy-entry-flow {\n  overflow-y: scroll; }\n\n@media only screen and (min-width: 600px) {\n  .fmcy-entry-flow-step-region-wrapper {\n    position: absolute;\n    margin: auto;\n    width: 500px;\n    height: 500px;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0; }\n  .fmcy-entry-flow-step-region {\n    width: 500px;\n    height: 500px; }\n  .fmcy-delivery-select-continue-button-bar,\n  .fmcy-age-gate-button-bar {\n    position: absolute !important;\n    background-color: #1c1c1c !important; }\n  .fmcy-entry-flow {\n    background-color: #000000 !important; }\n  .fmcy-entry-flow-step-region {\n    background-color: #1c1c1c !important; } }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/entry-flow/entry-flow.scss
 ** module id = 967
 ** module chunks = 1 39
 **/